import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Card, Hidden, Container, Typography } from '@material-ui/core';
import { ComponentsLib } from '@payface-frontends-libs/components';
const { Page, Logo } = ComponentsLib.Generics;
const { LoginForm, VerifyCode } = ComponentsLib.Authentication;
const RootStyle = styled(Page)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
    },
}));
const HeaderStyle = styled('header')(({ theme }) => ({
    top: 0,
    zIndex: 9,
    lineHeight: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    padding: theme.spacing(3),
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
        alignItems: 'flex-start',
        padding: theme.spacing(7, 5, 0, 7),
    },
}));
const SectionStyle = styled(Card)(({ theme }) => ({
    width: '100%',
    maxWidth: 464,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(2, 0, 2, 2),
}));
const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(12, 0),
}));
export function Login(loginProps) {
    const { loginEndpoint, pageName, verifyPath, passwordEndpoint, otpEndpoint } = loginProps;
    const [showVerify, setShowVerify] = useState(JSON.parse(sessionStorage.getItem('verify')) || '');
    const handleVerify = (state) => {
        setShowVerify(state);
    };
    useEffect(() => {
        showVerify && sessionStorage.setItem('verify', JSON.stringify(showVerify));
    }, [showVerify]);
    return (_jsxs(RootStyle, Object.assign({ title: "Login \u30C4" }, { children: [_jsx(HeaderStyle, { children: _jsx(RouterLink, Object.assign({ to: "/" }, { children: _jsx(Logo, {}, void 0) }), void 0) }, void 0), _jsx(Hidden, Object.assign({ mdDown: true }, { children: _jsxs(SectionStyle, { children: [_jsx(Typography, Object.assign({ variant: "h3", sx: { px: 5, mt: 15, mb: 15 } }, { children: "Ol\u00E1, Bem vindo de volta" }), void 0), _jsx("img", { src: "/static/illustrations/illustration_login.svg", alt: "login" }, void 0)] }, void 0) }), void 0), _jsx(Container, Object.assign({ maxWidth: "sm" }, { children: _jsxs(ContentStyle, { children: [_jsx(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: _jsxs(Typography, Object.assign({ variant: "h2", gutterBottom: true }, { children: [`Payface ${pageName} `, _jsx("span", Object.assign({ style: { color: '#7bab00' } }, { children: "\u30C4" }), void 0)] }), void 0) }), void 0), showVerify ? (_jsx(VerifyCode, { verifyPath: verifyPath, otpEndpoint: otpEndpoint, passwordEndpoint: passwordEndpoint, handleVerify: handleVerify }, void 0)) : (_jsx(LoginForm, { loginEndpoint: loginEndpoint, handleVerify: handleVerify }, void 0))] }, void 0) }), void 0)] }), void 0));
}
//# sourceMappingURL=Login.js.map